import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

function CollapsibleSection({ 
  title, 
  icon, 
  description, 
  children, 
  defaultOpen = false,
  badge = null 
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-white rounded-lg shadow-lg mt-8 overflow-hidden border border-gray-200">
      {/* Header Clickeable */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          {icon && <span className="text-2xl">{icon}</span>}
          <div className="text-left">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              {title}
              {badge && (
                <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
                  {badge}
                </span>
              )}
            </h3>
            {description && (
              <p className="text-sm text-gray-600 mt-0.5">{description}</p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-500">
            {isOpen ? 'Ocultar' : 'Mostrar'}
          </span>
          {isOpen ? (
            <ChevronUp size={24} className="text-gray-400" />
          ) : (
            <ChevronDown size={24} className="text-gray-400" />
          )}
        </div>
      </button>

      {/* Contenido Colapsable */}
      {isOpen && (
        <div className="border-t border-gray-200">
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleSection;